import { cn } from "../../lib/utils";

const STATUS_COLORS = {
  active: "bg-emerald-100 text-emerald-700 border-emerald-200",
  pending: "bg-amber-100 text-amber-700 border-amber-200",
  inactive: "bg-slate-100 text-slate-500 border-slate-200",
  suspended: "bg-red-100 text-red-700 border-red-200",
  published: "bg-emerald-100 text-emerald-700 border-emerald-200",
  draft: "bg-slate-100 text-slate-500 border-slate-200",
  archived: "bg-slate-200 text-slate-600 border-slate-300",
  open: "bg-blue-100 text-blue-700 border-blue-200",
  closed: "bg-slate-100 text-slate-500 border-slate-200",
  in_progress: "bg-amber-100 text-amber-700 border-amber-200",
};

export default function StatusBadge({ status, label, className }) {
  const colorClass = STATUS_COLORS[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition-all duration-200 hover:scale-105",
        colorClass,
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current animate-pulse" />
      {label || status}
    </span>
  );
}